// extracted by mini-css-extract-plugin
export default {"asset-info":"styles__asset-info--AQgpK","info-dot":"styles__info-dot--qtzr4"};